import { ConnectionError_Reason } from "@inline-chat/protocol/core";
export class InlineSdkAuthenticationError extends Error {
    code;
    reason;
    terminal = true;
    constructor(code, reason) {
        super(`Inline authentication failed: ${code}`);
        this.code = code;
        this.reason = reason;
        this.name = "InlineSdkAuthenticationError";
    }
}
export function authenticationErrorFromConnectionReason(reason) {
    switch (reason) {
        case ConnectionError_Reason.UNAUTHORIZED:
            return new InlineSdkAuthenticationError("UNAUTHORIZED", reason);
        case ConnectionError_Reason.INVALID_AUTH:
            return new InlineSdkAuthenticationError("INVALID_AUTH", reason);
        case ConnectionError_Reason.SESSION_REVOKED:
            return new InlineSdkAuthenticationError("SESSION_REVOKED", reason);
        default:
            return null;
    }
}
